module.exports = __webpack_public_path__ + "resources/footer-qrcode-8940d17e7d503988b14ffe27242dc226.png";


//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/resources/images/footer-qrcode.png
// module id = 61
// module chunks = 0 51